import axios from '../helpers/axios'
import { logError } from '../services';
import { IPartClass } from '../models/part-classes';
export const getPartClasses = async (filters?: {
    name?: string;
  }): Promise<IPartClass[]> => {
    try {
      const { data } = await axios.get(`/api/parts/part-class`, {
        params: filters
      });
      return data;
    } catch (error) {
      logError(error, 'getMaterialList failed');
      return Promise.reject(error);
    }
  };